module.exports = __webpack_public_path__ + "img/calendar-clock.2ece1aa3.svg";